import { SearchScope } from './types';
import { CatalogueSearchScope, CollectionSearchScope } from '../../../store/api';
import {
    SCOPE_ALL_OBJECT,
    SCOPE_CATALOGUE_OBJECT,
    SCOPE_EAUDIOBOOK_OBJECT,
    SCOPE_EBOOK_OBJECT,
    SCOPE_EPRESS_OBJECT,
    SCOPE_LANGUAGELEARNING_OBJECT,
    SCOPE_LOTE_OBJECT
} from './constants';

export function mapLanguageScopeKeyToCamelCase(searchScope: SearchScope) {
    switch (searchScope.key) {
        case SCOPE_LANGUAGELEARNING_OBJECT.key:
            return 'languageLearning';
        case SCOPE_LOTE_OBJECT.key:
            return 'lote';
        default:
            return null;
    }
}

export function getCatalogueSearchScopes(isMultiLanguageShopEnabled: boolean) {
    if (isMultiLanguageShopEnabled) {
        return [
            SCOPE_EAUDIOBOOK_OBJECT,
            SCOPE_EBOOK_OBJECT,
            SCOPE_EPRESS_OBJECT,
            SCOPE_LANGUAGELEARNING_OBJECT,
            SCOPE_CATALOGUE_OBJECT
        ];
    }

    return [
        SCOPE_EAUDIOBOOK_OBJECT,
        SCOPE_EBOOK_OBJECT,
        SCOPE_EPRESS_OBJECT,
        SCOPE_LOTE_OBJECT,
        SCOPE_LANGUAGELEARNING_OBJECT,
        SCOPE_CATALOGUE_OBJECT
    ];
}

export function getYourBorrowBoxSearchScopes() {
    return [SCOPE_EAUDIOBOOK_OBJECT, SCOPE_EBOOK_OBJECT, SCOPE_EPRESS_OBJECT, SCOPE_ALL_OBJECT];
}

export const mapCollectionSearchScope = (scope: string): CollectionSearchScope => {
    switch (scope.toUpperCase()) {
        case 'EBOOKS':
            return CollectionSearchScope.EBOOKS;
        case 'EAUDIOBOOKS':
            return CollectionSearchScope.EAUDIOBOOKS;
        case 'EMAGAZINES':
        case 'EPRESS':
            return CollectionSearchScope.EPRESS;
        case 'ALL':
        default:
            return CollectionSearchScope.ALL;
    }
};

export const mapCatalogueSearchScope = (scope: string): CatalogueSearchScope => {
    switch (scope.toUpperCase()) {
        case 'EBOOKS':
            return CatalogueSearchScope.EBOOKS;
        case 'EAUDIOBOOKS':
            return CatalogueSearchScope.EAUDIOBOOKS;
        case 'LOTE':
            return CatalogueSearchScope.LOTE;
        case 'LANGUAGE_LEARNING':
            return CatalogueSearchScope.LANGUAGE_LEARNING;
        case 'EPRESS':
        case 'EMAGAZINES':
            return CatalogueSearchScope.EPRESS;
        case 'CATALOGUE':
        default:
            return CatalogueSearchScope.CATALOGUE;
    }
};
